import React,{useState,useEffect} from 'react';
import ResetServidor from './ResetServidor';
import TemperaturaFreidoras from './TemperaturaFreidoras';

function MenuHerramientas({regional}) {
    const [vista,setVista] = useState(0);
    function getVista(){
        if(vista===0){
            return (<ResetServidor regional={regional}/>)
        }else if (vista===1){
            return (<TemperaturaFreidoras/>)
        }
    }
    useEffect(()=>{

    },[vista])
    return (
        <div>
            <nav className="navbar navbar-expand-sm navbar-dark bg-dark bg-gradient">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fa-solid fa-list-ul text-white"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className={vista===0?"nav-item selected bg-gradient":"nav-item bg-gradient"} onClick={()=>setVista(0)}>
                                <a className="nav-link active"><i className="fa-solid fa-spinner"></i> Reset Server/Password</a>
                            </li>
                            <li className={vista===1?"nav-item selected bg-gradient":"nav-item bg-gradient"} onClick={()=>setVista(1)}>
                                <a className="nav-link active"><i className="fa-solid fa-temperature-high"></i> Freidoras</a>
                            </li>
                            <li className={vista===2?"nav-item selected bg-gradient":"nav-item bg-gradient"} onClick={()=>setVista(2)}>
                                <a className="nav-link active"><i className="fa-solid fa-file-invoice-dollar"></i> Facturas</a>
                            </li>
                            <li className="nav-item dropdown bg-gradient">
                                <a className="nav-link dropdown-toggle active" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fa-solid fa-screwdriver-wrench"></i> Utils
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="#">Empleado</a></li>
                                    <li><a className="dropdown-item" href="#">Permisos</a></li>
                                    <li><hr className="dropdown-divider"/></li>
                                    <li><a className="dropdown-item" href="#">Bajas</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            {getVista()}
        </div>
    )
}

export default MenuHerramientas
